<!--
 * @Author: chenguanghua
 * @Date: 2022-07-25 16:58:32
 * @LastEditors: zxf
 * @LastEditTime: 2023-08-23 17:23:55
 * @Description: 维保报告管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ dlTypeStr }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <!-- <k-button
          btn-text="导出"
:auth-type="false"
          type="primary"
          @click="handleDialog('edit',{ id:scope.row.id })"
        >
          同步到社会单位系统
        </k-button>
        <k-button
          btn-text="导出"
:auth-type="false"
          type="primary"
          @click="handleDialog('edit',{ id:scope.row.id })"
        >
          同步所有到社会单位系统
        </k-button> -->
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <el-input
                  v-model.trim="filterParams.bgbh"
                  class="c-form__input"
                  placeholder="报告编号"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="计划名称"
                prop="jhmc"
              >
                <el-input
                  v-model.trim="filterParams.jhmc"
                  class="c-form__input"
                  placeholder="计划名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="wbbgTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #jhmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'viewWbjh', params: { id: scope.row.jhId } })"
              >
                {{ scope.row.jhmc }}
              </el-link>
            </template>
            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <template
              #shdw="scope"
            >
              {{ scope.row.shdw == 'Y' ? "是" : "否" }}
            </template>

            <!-- <template
              #wbryMc="scope"
            >
              <template v-for="(item,index) in scope.row.wbryMc">
                {{ item }}{{ scope.row.wbryMc.length === index + 1 ?' ': '、' }}
              </template>
            </template> -->
            <el-table-column
              prop="enabled"
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.tsbz !== 'Y'"
                  v-permission-element="'wbxm_sqxg'"
                  btn-text="申请修改"
                  :auth-type="true"
                  type="warning"
                  plain
                  @click="handleDialog('sqxg',{wbjhId:scope.row.jhId, id: scope.row.xmId})"
                />
                <k-button
                  btn-text="公示牌"
                  :auth-type="false"
                  type="primary"
                  plain
                  @click="handleDialog('gsp',{ id: scope.row.jhId })"
                />
                <!-- <k-button
          btn-text="导出"
:auth-type="false"
                  type="primary"
                  plain
                  @click="handleDialog('dybq',{ id:scope.row.jhId })"
                >
                  打印标签
                </k-button> -->
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 新增 -->
    <dybq-dialog
      v-if="showDialogName==='dybq'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search()"
    />
    <!-- 申请修改 -->
    <sqxg-dialog
      v-if="showDialogName === 'sqxg'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
    <!-- 公示牌 -->
    <gsp-dialog
      v-if="showDialogName === 'gsp'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
    />
    <!-- 页面主内容：查询列表 End -->
  </div>
</template>

<script>
import { bgglService } from './bggl.service.js';
export default {
  name: 'BgglIndex',
  components: {
    dybqDialog: () => import('./dybqDialog.vue'),
    SqxgDialog: () => import('./SqxgDialog.vue'),
    GspDialog: () => import('./gspDialog.vue')
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        bgbh: null, // 报告编号
        jhmc: null, // 计划名称
        xmmc: null, // 项目名称
        bgType: null,
        bglx: ['DGZ', 'DQZ', 'YQZ', 'YGZ', 'YFB'] // 计划状态代码
      },
      /* 查询条件 end */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jhmc', slotName: 'jhmc', label: '计划名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '220', type: 'text' },
        { key: 'xmmc', label: '项目名称', align: 'left', minWidth: '220', type: 'text' },
        { key: 'jhztMc', label: '状态', align: 'center', width: '100', type: 'text' },
        { key: 'areaMc', label: '所属区域', align: 'left', minWidth: '130', type: 'text' },
        // { key: 'shdw', slotName: 'shdw', label: '社会单位', align: 'center', width: '70', type: 'text' },
        { key: 'xmfzrMc', label: '项目负责人', align: 'left', minWidth: '100', type: 'text' },
        { key: 'jsfzrMc', label: '技术负责人', align: 'left', minWidth: '120', type: 'text' }
        // { key: 'lrdw', label: '录入单位', align: 'left', minWidth: '130', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  computed: {
    /** 动态获取路由名称 */
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta.navtabTitle;
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      if (this.filterParams.address) {
        const address = JSON.parse(this.filterParams.address);
        this.filterParams.province = address[0] ? address[0].name : null;
        this.filterParams.district = address[1] ? address[1].name : null;
        this.filterParams.city = address[2] ? address[2].name : null;
      }
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));

      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      bgglService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
       * @description: 弹窗处理方法
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name || '';
      this.dialogParams = _params || {};
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此维保签到任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      bgglService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 维保申请重新生成维保报告
     * @param {*}
     * @return {*}
     */
    handleSqxg () {
      this.refreshSearch();
    }
  },
  created () {
    const _routerName = this.$route.name;
    this.filterParams.bgType = _routerName.toUpperCase();
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
